export const formatData = ({ rows, level = "", parentRowId = "", columnInfo }) => {
  if (!rows) {
    return
  }
  let newArr = [];
  let serial = level;
  rows.map((i, e) => {

    const { rowId, cells, children } = i


    const s = e + 1 + "";
    let n = {
      rowId: rowId,
      parentRowId: !parentRowId ? rowId : parentRowId + ";" + rowId,
      grandParentSerial: !serial.includes(".")
        ? ""
        : serial.substring(0, serial.lastIndexOf(".")),
      serial: !serial ? s : serial + "." + s,
      parentSerial: serial,
    };



    const adf = setRow({ row: i, columnInfo, parentRowId });
    console.log(adf);


    n = { ...n, ...adf }

    // cells.map((j, e) => {
    //   const val = j?.val || "";
    //   Object.assign(n, { [columns[e + 1]["field"]]: val });
    // });

    n.children = !children
      ? []
      : formatData({ rows: children, columnInfo, level: n.serial, parentRowId: n.parentRowId });
    newArr.push(n);
  });
  console.log(newArr);


  return newArr;
};

function getXXRow(columnInfo) {
  const { uiTypes, editable, listEntries = {}, listIds } = columnInfo;
  var rows_type = columnInfo.uiTypes;
  var rows_editable = columnInfo.editable;

  // const listEntries = columnInfo.listEntries || [];
  const listEntriesKeys = Object.keys(listEntries);
  const caslistEntries = listEntriesKeys.filter(
    (i) => Object.keys(listEntries[i]) == -1
  );
  const relTypeList = [{ id: 4, icon: "el-icon-connection" }];

  let casList = [];
  let ids = columnInfo.listIds;
  caslistEntries.map((i) => {
    listIds.map((j, e) => j == i && casList.push(e));
  });

  const enabled_ids = [1090002, 1092004];
  const enabled_indexs = columnInfo.ids.findIndex((i) =>
    enabled_ids.includes(i)
  );
  return { rows_type, rows_editable, casList };
}

function getVal(type, qwe, M, editable) {
  if (type == 4) {
    return (qwe.ids || '').split(';')
    // rols_[j] = cells[j]?.ids || "";
    // // rols_[j] = cells[j].ids;
    // if (rols_[j] !== "") {
    //   rols_[j] = rols_[j].split(";");
    // }
  }
  else if (type == 3) {

    if (M) {
      return qwe.id == -1 ? '' : qwe.id
    }
    else {
      const { val, id } = qwe;
      return (id === -1 || !editable) ? val : id
      // !rows_editable[j] || (val.val && ids[j] == -1)
      //   ? val.val
      //   : val.id;
    }



  } else if (type == 6) {
    const [val] = (qwe.val || '').split('T');
    return val
    // if (cells[j].val == "") {
    //   rols_[j] = "";
    // } else {
    //   const [a] = cells[j].val.split('T')
    //   rols_[j] = a
    // }

  } else {
    // rols_[j] = cells[j].val;
    return qwe.val
  }

}



function setRow({ row, columnInfo, parentRowId }) {
  // var rols_ = {};
  console.log(parentRowId);

  let cellDisable = [];
  let changeIdIndex = 0; //获取表格变更列的版本id

  const { cells, objId: id, objClass: classId, objSubClass: subClassId, ...AA } = row;
  const { rows_type, rows_editable, casList } = getXXRow(columnInfo)

  // const { fileId, authTag, filePath, hasRev, isBOM, isFile, revNumberList, cells } = item
  const objectId = { id, classId, subClassId, }

  const BB = cells.map((j, e) => {
    if (columnInfo.ids[e] == 1003116) {
      changeIdIndex = e  //?
    }
    const editable = parentRowId ? false : j.editable;
    cellDisable.push(editable);
    const uiType = rows_type[e];
    const str = getVal(uiType, j, casList.includes(e), rows_editable[e]);

    return str
  })
  return { ...BB, ...AA, cellDisable, objectId }


  // for (var j = 0; j < cells.length; j++) {
  //   if (columnInfo.ids[j] == 1003116) {
  //     //获取表格变更列的版本id
  //     changeIdIndex = j;
  //   }

  //   // if (cells[j] == null) {
  //   //   (rols_[j] = ""), cellDisable.push("null");
  //   // } else {

  //   //   cellDisable.push(cells[j].editable);

  //   // }
  // }
  // if (item.hasChildren == true) {
  //   rols_["hasChildren"] = item.hasChildren;
  // }
  // rols_["cellDisable"] = cellDisable;
  // rols_["itemId"] = item.objId;
  // rols_["itemClassId"] = item.objClass;
  // rols_["itemSubClassId"] = item.objSubClass;
  // rols_["relType"] =
  //   relTypeList.find((item) => item.id == (item?.relType || ""))
  //     ?.icon || "";

  // rols_.objectId = {
  //   id: item.objId,
  //   classId: item.objClass,
  //   subClassId: item.objSubClass,
  //   name: "",
  // };
  // rols_ = { rowId, fileId, authTag, filePath, hasRev, isBOM, isFile, revNumberList, ...rols_ };

  // if (enabled_indexs != -1) {
  //   rols_["status"] = cells[enabled_indexs].id == 1;
  // }

  // if (projectName == "performance") {
  //   rols_["changeId"] = "";
  // } else {
  //   rols_["changeId"] = cells[changeIdIndex].id; //获取表格变更列的版本id
  // }

  // return rols_

};

export const getNewTableContentData = function (rows, columnInfo, projectName) {
  //获取到table进行格式转换
  var data = [];

  var rows_val = rows ?? [];


  // rows.map((item, index) => {
  //   const cell = cells;
  // })

  for (var i = 0; i < rows_val.length; i++) {

    //data.push(rols_);

  }

  return data;//
};

const toBuffer = (wbout) => {
  let buf = new ArrayBuffer(wbout.length);
  let view = new Uint8Array(buf);
  for (let index = 0; index !== wbout.length; ++index)
    view[index] = wbout.charCodeAt(index) & 0xff;
  return buf;
};



export default {
  formatData,
  toBuffer,
};
